import { render, staticRenderFns } from "./RequestLabelModal.vue?vue&type=template&id=31ac3387"
import script from "./RequestLabelModal.vue?vue&type=script&lang=js"
export * from "./RequestLabelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports